import { render, staticRenderFns } from "./PersonifiableUser.vue?vue&type=template&id=4054aa38&"
import script from "./PersonifiableUser.vue?vue&type=script&lang=js&"
export * from "./PersonifiableUser.vue?vue&type=script&lang=js&"
import style0 from "./personifiable-user.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports